const systems = [
    {
        id: 1,
        name: 'Windows',
        src: '../img/logos/windows.png',
    },
    {
        id: 2,
        name: 'Linux',
        src: '../img/logos/linux.png'
    }
]
export default systems